import { UrlSearchFilterProperty } from '@/constants';
import { useUrlFilter } from '@/hooks';

import { DateRangePicker } from './date-range-filter.component';

export const DateRangePickerUrlFilter: React.FC = () => {
    const { setSearchFilter, getSearchFilter } = useUrlFilter();

    const fromDate =
        getSearchFilter(UrlSearchFilterProperty.DATE_FROM) ||
        new Date().toDateString();
    const toDate =
        getSearchFilter(UrlSearchFilterProperty.DATE_TO) ||
        new Date().toDateString();

    return (
        <DateRangePicker
            initialDateFrom={new Date(fromDate)}
            initialDateTo={new Date(toDate)}
            onUpdate={(values) => {
                if (!values?.range?.from || !values?.range?.to) {
                    return;
                }
                setSearchFilter(
                    UrlSearchFilterProperty.DATE_FROM,
                    values.range.from?.toDateString(),
                );
                setSearchFilter(
                    UrlSearchFilterProperty.DATE_TO,
                    values.range.to?.toDateString(),
                );
            }}
        />
    );
};
